import Config from '../../config'

export const getCustomers = (host: string, token: string) => {
    const reqestURL = `${host}/${Config.version}/customers`;
    const reqestHeader: HeadersInit = new Headers();
    reqestHeader.set("Content-Type", "application/json");
    reqestHeader.set("Authorization", `Bearer ${token}`);

    return fetch(reqestURL, {
        method: "GET",
        headers: reqestHeader
    })
        .then(response => response.json())
        .then(response => {
            if (response.status.code === 200) {
                return response.data ? response.data : response;
            } else {
                return response;
            }
        })
        .catch((error: any) => error);
}